<template>

  <div v-loading="loading">
    <el-card>
      <div style="margin: 0 0 6px 0; color: #999" v-if="!!this.missingRows">{{ "," +
        $t("message.title.missingRows")
      }}</div>

      <!-- <el-row :gutter="20">
        <el-col :span="8">
          <el-input clearable size="small" :placeholder="$t('message.placeholder.input')" v-model="search"
            class="input-with-select" @clear="searchDeletedObj()" @keyup.enter.native="searchDeletedObj()">
            <el-button slot="append" icon="el-icon-search" @click="searchDeletedObj"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2">
            <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="restoreObjects">{{
              $t('message.button.Undo') }}
            </el-button>
            <el-button class="btn btn2" icon="el-icon-delete" @click="deleteObjects"
            >{{
              $t('message.button.delete') }}
          </el-button>
        </el-col>
      </el-row> -->

      <div class="show-table">
        <vxe-grid ref='xGrid' v-bind="gridOptions" :scroll-y="{ enabled: true }" :toolbar-config="tableToolbar"
          @cell-dblclick='cellClick' :row-style="rowStyle"
          :cell-style="{ padding: '3px', 'font-size': '12px', 'line-height': '16px ' }"
          @checkbox-change="checkboxChangeEvent" @checkbox-all="checkboxChangeEvent">

          <template #toolbar_buttons>
          
          <el-row :gutter="50">
            <el-col :span="600">
              <el-input clearable size="small" :placeholder="$t('message.placeholder.input')" v-model="search"
                class="input-with-select" @clear="searchDeletedObj()" @keyup.enter.native="searchDeletedObj()">
                <el-button slot="append" icon="el-icon-search" @click="searchDeletedObj"></el-button>
              </el-input>
            </el-col>
            <el-col :span="50">
                <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="restoreObjects">{{
                  $t('message.button.Undo') }}
                </el-button>
                <el-button class="btn btn2" icon="el-icon-delete" @click="deleteObjects"
                >{{
                  $t('message.button.delete') }}
              </el-button>
            </el-col>
          </el-row>

            <!-- <el-button class="btn btn7" icon="el-icon-document-checked" @click="getUpdateEvent" v-if="!editShow"
            :disabled='!editTable || !addTableListPriv'>{{
              $t('message.button.save') }}
          </el-button>
          <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave" v-if="!editShow"
            :disabled='!editTable || !addTableListPriv'>{{
              $t('message.button.cancel') }}
          </el-button> -->
          </template>

        </vxe-grid>
        <el-pagination small class="pagination" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[100, 200, 500, 1000]" :page-size="1000"
          :current-page='currentPage' layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from "axios";
import SearchQuery from "./searchItem/search.vue";
import { setColumns } from './showTable';
import { LINK_LIST } from "@/utils/constants";
import { VXETable, } from 'vxe-table';

import DemoFilterContent from '../../../components/common/filterContent.vue'

VXETable.renderer.add('MyTableFilterContent', {
  // 不显示底部按钮，使用自定义的按钮
  showTableFilterFooter: false,
  // 自定义筛选模板
  renderTableFilter(h, renderOpts, renderParams) {
    return <DemoFilterContent render-params={renderParams} />
  },
  // 自定义重置数据方法
  tableFilterResetMethod(params) {
    const { options } = params
    options.forEach((option) => {
      option.data = { vals: [], sVal: '' }
    })
  },
  // 自定义筛选数据方法
  tableFilterMethod(params) {
    const { option, row, column } = params
    const { vals } = option.data
    const cellValue = row[column.field]
    return vals.includes(cellValue)
  }
})


export default {
  name: "DeletedObjects",
  data() {
    return {
      search: '',
      // baseClassId:'',
      loading: false,
      tableShow: false,

      selectRecords: [],

      pageSizes: [100, 200, 500, 1000],
      pageSize: 1000,
      currentPage: 1,
      totalRecords: 0,
      missingRows: 0,

      select_value: "",
      tableToolbar: {
        buttons: [{ code: 'myInsert', name: '', type: 'text', },],
        // print: true,
        // print: true,
        // export:true,
        zoom: true,
        custom: true,
        slots: {
          buttons: 'toolbar_buttons'
        }
        // slots: {
        //   tools: "tools",
        // },
      },
      gridOptions: {

        printConfig: {},
        keepSource: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,

        toolbarConfig: {
          zoom: true,
          custom: true,
          slots: {
            buttons: 'toolbar_buttons'
          }
        },

        rowId: "id",
        size: "small",
        border: true,
        resizable: true,
        showOverflow: true,
        stripe: true,
        height: 660,
        align: 'left',
        columns: [{
          type: 'checkbox',
          width: 60,
          fixed: null
        }],
        data: []
      },
      rowStyle: { cursor: 'pointer' },
    };
  },
  components: {
    SearchQuery,
  },
  computed: {
    getPage() {
      const { id, val } = this.$route.query
      console.log(id, val);

      return { id, val }
    },
  },
  watch: {
    getPage(newVal) {
      // console.log(val);
      // const { id, val } = newVal
      this.search = '';
      // this.setSearch({ 'value': this.search });
      this.setSearch();
    }
  },
  mounted() { },
  methods: {
    restoreObjects() {

      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      console.log(removeRow);
      var unDelObjIds = [];
      var classIds = [];
      var vm = this;
      if (removeRow.length == 0) {
        return false
      } else {
        console.log(removeRow);
        for (var i = 0; i < removeRow.length; i++) {
          // var obj = {};
          // obj.id = removeRow[i].objectId.id;
          // obj.classId = removeRow[i].objectId.classId;
          // obj.subClassId = removeRow[i].objectId.subClassId;
          unDelObjIds.push(removeRow[i].objectId.id);
          classIds.push(removeRow[i].objectId.classId);
        };
        var UnDeleteObjsVo = {
          unDelObjIds: unDelObjIds,
          classIds: classIds,
        };
        console.log(UnDeleteObjsVo);
        axios.post('/pmdm/ObjectCommon/unDeleteObjs', UnDeleteObjsVo).then(function (res) {
          if (res.data.code == 200) {
            vm.$message({
              message: res.data.message,
              type: 'success'
            });
            console.log(res);
            vm.selectRecords = [];
            vm.setSearch({});
          }
        })
          .catch(function (error) {
            console.log(error);
          });
      }
      //console.log(removeRow);
    },
    searchDeletedObj() {
      this.setSearch({ 'value': this.search });
      console.log(this.search);
      
    },
    getInfo($panel, dataObj, column) {
      $panel.confirmFilter()
      //下一步操作
      //dataObj.data:查询输入框参数
      //column.property:表格列
    },

    checkboxChangeEvent({ records }) {
      // const $grid = this.$refs.xGrid;
      // this.selectRecords = records;
      console.log(records);

    },
    deleteObjects() {

      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      console.log(removeRow);
      var delObjIds = [];
      var classIds = [];
      var vm = this;
      if (removeRow.length == 0) {
        return false
      } else {
        console.log(removeRow);
        for (var i = 0; i < removeRow.length; i++) {
          // var obj = {};
          // obj.id = removeRow[i].objectId.id;
          // obj.classId = removeRow[i].objectId.classId;
          // obj.subClassId = removeRow[i].objectId.subClassId;
          delObjIds.push(removeRow[i].objectId.id);
          classIds.push(removeRow[i].objectId.classId);
        };
        var deleteObjsVo = {
          unDelObjIds: delObjIds,
          classIds: classIds,
        };
        console.log(deleteObjsVo);

        this.$confirm(this.$t('message.confirm.deleteData'), this.$t('message.tips.tip'), {
          confirmButtonText: this.$t('message.button.affirm'),
          cancelButtonText: this.$t('message.button.cancel'),
          type: 'warning'
        }).then(() => {
          
          axios.post('/pmdm/ObjectCommon/deleteObjs', deleteObjsVo).then(function (res) {
          if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: 'success'
              });
              console.log(res);
              vm.selectRecords = [];
              vm.setSearch({});
            }
          })
          .catch(function (error) {
            console.log(error);
          });


        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('message.tips.deleteCancel')
          });
        });

        
      }
      //console.log(removeRow);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.setSearch({ size: val , 'value': this.search });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.setSearch({ page: val , 'value': this.search});
      // const { data: res } = await this.$http.get(loadTableUrl);
    },
    baseIdChange() {
      this.currentPage = 1;
    },

    cellClick({ row, }) {
      // this.rowClick(row);
    },
    rowClick(row, column, event) {
      this.getLink(row.objectId);
    },


    async setSearch(obj) {
      // this.loading = true;
      this.gridOptions.columns = [{
        type: 'checkbox',
        width: 60,
        fixed: null
      }];
      console.log(obj);
      // console.log(this.baseClassId);
      const { query } = this.$route;
      console.log(query);

      const { id, val: value, size, page, baseClassId } = query;
      //Number(101)
      const param = { deleted: 1, baseClassId: Number(baseClassId), value, 'size': this.pageSize || Number(size), 'page': this.currentPage || Number(page), id, ...obj };

      const urlMap = new Map([
        [301, `/ppm/project/simpleSearch`],
        [401, `/pqm/quality/simpleSearch`]
      ])
      const url = urlMap.get(Number(id)) || `/pmdm/search/simpleSearch`;

      console.log(param);

      const { data } = await axios.post(url, param);
      const { columnInfo, rows, totalRecords, rowMissing } = data.object.table
      this.showTable({ columnInfo, rows });
      this.records = { totalRecords, rowMissing };
      this.totalRecords = totalRecords
      this.loading = false
    },


    setTableInfo({ totalRecords, rowMissing }) {
      this.tableToolbar.buttons[0].name = this.$t('message.title.totalResults') + totalRecords + this.$t('message.title.resultsNums');
      this.missingRows = rowMissing;
    },

    showTable({ columnInfo, rows }) {


      // this.gridOptions.columns = [...this.gridOptions.columns, ...setColumns(columnInfo)].map((item, index) => {
      //   item = {
      //     ...item,
      //     'filters': [{ data: { vals: [], sVal: '' } }],
      //     'filterRender': {
      //       name: 'MyTableFilterContent',
      //       events: {
      //         click: ($panel, dataObj, column) => {
      //           this.getInfo($panel, dataObj, column)
      //         }
      //       }
      //     }
      //   }
      //   return item
      // });

      // this.gridOptions.columns = [...this.gridOptions.columns ,...setColumns(columnInfo)];
      this.gridOptions.columns = [...this.gridOptions.columns ,...setColumns(columnInfo)].map((item, index) => {
        item = {
          ...item,
          'showOverflow': 'title',
        }
        return item
      });
      console.log(this.gridOptions.columns);

      this.gridOptions.data = rows.map(i => {
        const row = {}, { cells, objId: id, objClass: classId, objSubClass: subClassId } = i;
        cells.map((j, e) => {
          row[e] = j?.val || ''
        })
        row.objectId = {
          subClassId, classId, id,
          title: cells[0].val
        }
        return row;
      })

    },

  },

  created() {
    // const { query } = this.$route;
    // this.baseClassId = query;    
    this.setSearch({});

  },

};
</script>

<style lang="scss" scoped>
.link_ {
  color: #4b92ff;
  cursor: pointer;

  &:hover {
    // color: #4b92ff;
    border-bottom: 1px solid #4b92ff;
  }
}
</style>